import React, { useContext, useEffect, useState } from "react";
import Loader from "./utility/Loader";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../App";
import { environment } from "../Env_data/environment";

const Onboarding = () => {
  const { APP_NAME } = environment;
  const { state, setState } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const { session } = state;
  const location = useLocation();
  const navigate = useNavigate();
  const [localChecked, setLocalChecked] = useState(false);

  const LOGIN_PATHS = ["/login", "/", "/signup", "/verify_email", "/forget"];
  const PROTECTED_PATHS = ["/panel", "/home"];

  // Load state from localStorage on mount
  useEffect(() => {
    const storedState = localStorage.getItem(APP_NAME);
    if (storedState) {
      setState(JSON.parse(storedState));
    }
    setLocalChecked(true);
  }, [APP_NAME, setState]);

  // Save state to localStorage whenever it changes
  useEffect(() => {
    if (state.session && Object.keys(state.session).length > 0) {
      localStorage.setItem(APP_NAME, JSON.stringify(state));
    }
  }, [state, APP_NAME]);

  // Handle navigation based on session and path
  useEffect(() => {
    if (localChecked) {
      if (location.pathname === "/whoami" || location.pathname.endsWith("/whoami") || location.pathname === "/authorize") {
        setLoader(false);
        return;
      }

      if (session?.id) {  
        if (LOGIN_PATHS.includes(location.pathname)||location.pathname==="/") {
          if(session?.homes?.length)
          navigate("/home");
        else    
        navigate("/panel");
      }
      } else if (PROTECTED_PATHS.includes(location.pathname)||location.pathname==="/") {
        navigate("/login");
      }

      const timeout = setTimeout(() => setLoader(false), 200);
      return () => clearTimeout(timeout); // Cleanup timeout
    }
  }, [localChecked, session, location.pathname, navigate]);

  if (loader) return <Loader fullPage />;

  return <Outlet />;
};

export default Onboarding;